<template lang="pug">
  .v-container
    .grid-container
      .row
        .col.s12
          .p-global-header__tom-logo(style="float: none; width: auto;")
            a(href="#", @click.prevent="$emit('close')") Tokyo Otaku Mode

      .row.u-mtl
        .col.s12.u-align-center
          img.c-tom-premium--inline(:src="'/images/tom_premium_h.svg' | staticImageUrl", alt="TOM Premium", style="height: 36px;")

      .row.u-mtm
        .col.s12
          // index
          template(v-if="route === 'index'")
            .catch.u-align-center
              template(v-if="lang === 'ja'")
                template(v-if="premiumPlanPrice > 0") 入会金<strong class="v-gain">{{ premiumPlanPrice | currency }}</strong>で
                template(v-else) 今なら初回入会30日間<strong class="v-gain">無料</strong>、<br><span style="font-size: 75%;">さらに</span>
                | <span style="font-size: 75%;">ご注文金額から最大</span> <strong class="v-gain">{{ premiumJoiningSavePrice | currency }}</strong> 割引！
              template(v-else)
                template(v-if="premiumPlanPrice > 0")
                  template(v-if="cart.premium.plan_type === 'first'")= "Join for "
                  template(v-else)= "Rejoin for "
                  | <strong class="v-gain">{{ premiumPlanPrice | currency }}</strong>
                template(v-else)
                  | Get your first 30 days <strong class="v-gain">FREE</strong>
                | <br />and save up to <strong class="v-gain">{{ premiumJoiningSavePrice | currency }}</strong> <br class="u-br--sm">on this order

            ul.u-fs-lg.c-list-check
              template(v-if="lang === 'ja'")
                li(v-if="!(premiumPlanPrice > 0)") 初回入会<strong class="v-em">30日間無料</strong>
                li プレミアム会員<strong class="v-em">限定割引</strong>
                li <strong class="v-em">無期限</strong>ポイント
                li 更新時約<strong class="v-em">110%ポイント還元</strong>

              template(v-else)
                li(v-if="!(premiumPlanPrice > 0)") 30 day <strong class='v-em'>FREE trial</strong>
                li <strong class='v-em'>Exclusive</strong> shop discounts
                li TOM Points <strong class='v-em'>never expire</strong>
                li <strong class='v-em'>110% cash back</strong> for renewing

            .row.u-mtl(v-if="!canGetBonus")
              .col.s12
                .c-message.c-message--danger
                  template(v-if="lang === 'ja'")
                    | この決済方法は既に別のアカウントで使用されています。この決済方法を利用した場合、TOMが提供するすべてのサービスの初回特典が得られないことをご了承ください。
                  template(v-else)
                    | This payment method is already linked to another account. Please know any orders paid for by this payment method will not include first-time purchaser benefits of any kind in relation to TOM services.

            .row.u-mtl
              .col.s12
                button.c-btn.c-btn--lg.c-btn--action.c-btn--fill.c-btn--wrap-text(type="button", @click="onSubmit")
                  template(v-if="lang === 'ja'") 入会して注文を確定する
                  template(v-else) Complete Order<br class="u-br--sm"> & Join Premium

              .col.s12.u-pts
                button.c-btn.c-btn--link.c-btn--fill(type="button", @click="onClose")
                  template(v-if="lang === 'ja'") 今は入会しない
                  template(v-else) Take me back

            .row.u-mtl
              .col.s12
                p.u-fs-sm
                  template(v-if="lang === 'ja'")
                    template(v-if="premiumPlanType === 'first'")
                      | 入会契約して注文を確定されることで、お客様は
                      a(@click="goToTerms", class="v-link") TOM Premium 利用規約
                      | 同意の上入会されたことになります。
                      br
                      | TOM Premium 会員の30日間の無料お試し期間の満了日に$14.99／90日間で自動更新されます。契約更新が完了すると更新毎に$16.50のTOMポイントを獲得できます。
                      | 契約の更新をキャンセルするためには、お客様のTOM プレミアム会員情報ページからいつでもキャンセルすることが可能です。
                    template(v-else)
                      | 入会契約して注文を確定されることで、お客様は
                      a(@click="goToTerms", class="v-link") TOM Premium 利用規約
                      | に同意の上入会されたことになります。TOM Premium 会員は90日間の契約が終了する7日前に$14.99／90日間で自動更新されます。契約更新が完了すると更新毎に$16.50のTOMポイントを獲得できます。契約の更新をキャンセルするためには、お客様のTOM プレミアム会員情報ページからいつでもキャンセルすることが可能です。
                  template(v-else)
                    template(v-if="premiumPlanType === 'first'")
                      | By joining
                    template(v-else)
                      | By rejoining
                    | &nbsp;
                    | via this purchase, you agree to the
                    | &nbsp;
                    a(@click="goToTerms", class="v-link") TOM Premium Terms & Conditions.
                    | &nbsp;
                    template(v-if="premiumPlanType === 'first'")
                      | Your Premium subscription will AUTO-RENEW at $14.99 (for the next 90 days) on day 30 of your free trial.
                      | You may cancel an upcoming renewal any time by visiting Your TOM Premium Membership page.
                    template(v-else)
                      | Your Premium subscription will AUTO-RENEW at $14.99 on your scheduled billing date, 7 days prior to the completion of your first 90 day membership period. In exchange, you’ll receive $16.50 in TOM Points each time. You may cancel an upcoming renewal any time by visiting Your TOM Premium Membership page.

          // terms
          template(v-else-if="route === 'terms'")
            iframe(width="100%", height="360px", :src="'/tos/premium?lang=' + lang")
            .u-mts
              button.c-btn.c-btn--link(type="button", @click="goToIndex") Back

      hr
      .row
        .col.s12
          .u-color-muted.u-fs-sm
            template(v-if="lang === 'ja'") ご注文を確定されますと、お客様は当サイトの<a href="/tos" target="_blank">利用規約</a>に同意の上、商品をご注文されたことになります
            template(v-else) By placing your order, you agree to Tokyo Otaku Mode's <a href="/tos" target="_blank">terms of use</a> and <a href="/privacy_guide_checkout" target="_blank">privacy policy</a>.

</template>

<script>
  import ShoppingCarts from '../../stores/schema/ShoppingCarts';

  import textUtil from '../../util/text';
  import urlUtil from '../../util/url';

  const ROUTE = {
    INDEX: 'index',
    TERMS: 'terms'
  };

  export default {
    data() {
      return {
        lang: 'en',
        route: ROUTE.INDEX
      };
    },
    props: {
      checkoutPremium: Function
    },
    filters: {
      currency: textUtil.currency,
      staticImageUrl: urlUtil.staticImageUrl
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      cart() {
        return this.$store.getters['cart/current'](
          {populate: ['shipments']}
        );
      },
      currentPayment() {
        return this.$store.getters['payments/current'];
      },
      premiumPlan() {
        if (!this.cart) return null;
        return this.$store.getters['premiumPlans/findOne'](
          {_id: this.cart.premium.plan}
        );
      },
      premiumPlanType() {
        return this.cart.premium.plan_type;
      },
      premiumPlanPrice() {
        return this.premiumPlan.type[this.premiumPlanType].price.value;
      },
      premiumJoiningSavePrice() {
        return this.ShoppingCarts.premiumJoiningSavePrice(this.cart, this.user);
      },
      // 特典が受け取れるかの判定
      canGetBonus() {
        return this.cart.premium.can_get_bonus && !this.currentPayment.already_used_for_premium;
      },
      ShoppingCarts() {
        return ShoppingCarts;
      }
    },
    methods: {
      goToIndex() {
        this.route = ROUTE.INDEX;
      },
      goToTerms() {
        this.route = ROUTE.TERMS;
      },
      onSubmit() {
        tom.helper.ga.push ['event', 'EC', 'Clicked', 'AgreeConfirmPremium', 1];
        this.checkoutPremium();
        this.$emit('close');
      },
      onClose() {
        tom.helper.ga.push ['event', 'EC', 'Clicked', 'CloseConfirmPremium', 1];
        this.$emit('close');
      }
    },
    created() {
      this.lang = this.$store.state.user.lang;
    }
  };
</script>

<style scoped>
  .v-gain {
    color: #e83929;
  }

  .v-em {
    background: linear-gradient(transparent 75%, #f1cf00 25%);
  }

  .v-container {
    margin: 0 auto;
    max-width: 640px;
    min-height: 100vh;
    padding: 40px 0;
  }

  .c-list-check {
    max-width: 280px;
    margin: 0 auto;
  }

  @media (max-width: 767px) {
    /* iOS Safariでデバイス高よりモーダル高が大きい場合にツールバーが被さってボタンが押下出来ない問題のワークアラウンド */
    .v-container {
      padding-bottom: 120px !important;
    }
  }
</style>
